// extracted by mini-css-extract-plugin
export default {"results":"Search_results--UV0"};